var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM12 3C7.02943 3 3 7.02943 3 12C3 16.9706 7.02943 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02943 16.9706 3 12 3Z",
    fill: "#2A3D4A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 9C8.5 7.06702 10.067 5.5 12 5.5C13.933 5.5 15.5 7.06702 15.5 9C15.5 10.933 13.933 12.5 12 12.5C10.067 12.5 8.5 10.933 8.5 9ZM12 7.5C11.1716 7.5 10.5 8.17158 10.5 9C10.5 9.82841 11.1716 10.5 12 10.5C12.8284 10.5 13.5 9.82841 13.5 9C13.5 8.17158 12.8284 7.5 12 7.5Z",
    fill: "#2A3D4A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.5C7.88106 15.5 6.14627 17.1482 6.00886 19.2318C5.97251 19.7829 5.4963 20.2002 4.94521 20.1638C4.39413 20.1275 3.97685 19.6513 4.01319 19.1002C4.21947 15.9724 6.82058 13.5 10 13.5H14C17.1753 13.5 19.7737 15.9658 19.9861 19.0878C20.0235 19.6388 19.6072 20.1159 19.0562 20.1533C18.5052 20.1908 18.0282 19.7745 17.9907 19.2235C17.8492 17.1438 16.1162 15.5 14 15.5H10Z",
    fill: "#2A3D4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user-circle.621cfd79caf68ae3d05919455cb7153d.svg";
export { ForwardRef as ReactComponent };